import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';

@Component({
  selector: 'app-make-enroll',
  templateUrl: './make-enroll.component.html',
  styleUrls: ['./make-enroll.component.scss']
})
export class MakeEnrollComponent implements OnInit {
  enrollForm:FormGroup;
  venID:string;
  pkgID:string;
  courseDetails:[];
  classes:string;
  course_schedule:[];
  batch:string;
  userList:[];
  firstName:string;
  lastName:string;
  studentName:string;
  phoneNummber:string;
  emailAddress:string;
  parentName:string;
  age:string;
  reqDetails:string;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private helperService:HelperService) {

      this.venID = this.activatedRoute.snapshot.paramMap.get('vendorID');     
      this.pkgID = this.activatedRoute.snapshot.paramMap.get('courseID');


      this.enrollForm = this.formBuilder.group({
        studentName: ['', Validators.required],
        phoneNummber: ['', Validators.required],
        emailAddress:['',Validators.required],
        parentName:['',Validators.required],
        age:[''],
        classes:[''],
        batch:[''],
        reqDetails:['',Validators.required]
      });

     }

  ngOnInit() {

    let packageData = {
      token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),
      hostID: this.helperService.studented_atob(this.helperService.getHostID()),
      courseID: this.pkgID,
      scheduleID: this.venID,
      pkgID: this.pkgID
    }

    this.apiService.packageDetails(packageData).subscribe((res:any)=>{    
      
      
      this.courseDetails = res.data.vendorPkg.data.courseDetails; 
      
      
      this.classes =  res.data.vendorPkg.data.courseDetails[0].id;

      this.course_schedule = res.data.vendorPkg.data.course_schedule; 

      this.batch = res.data.vendorPkg.data.course_schedule[0].scheduleID;

    })

    const userData = {
      token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),     
      vendorID:this.venID,
      hostID: this.helperService.studented_atob(this.helperService.getHostID()),
    }

    this.apiService.userDetails(userData).subscribe((res:any)=>{    
     
      this.userList = res.data.getUserData.data;      
      this.firstName = res.data.getUserData.data.firstName;
      this.lastName = res.data.getUserData.data.lastName;

      this.studentName = this.firstName + " " +  this.lastName;
      this.phoneNummber = res.data.getUserData.data.phoneNumber;
      this.emailAddress = res.data.getUserData.data.user.userEmail;



  },async err => {
     
  })

  }

  


  

  saveEnrollment(){

    


  }

}
